<template>
  <div class="aw-cases-detail">
    <div class="com-sub-top">
      <div class="container-center cases-detail-title">
        <p class="detail-all" @click="goList">
          <i class="icon iconfont icon-fj-btnback arrow"></i>全部案例
        </p>
        <p class="detail-title">{{ name }}</p>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center detail-text">
        <div class="item-desc m-desc">
          <img class="logo" :src="logoUrl || placeholder" alt="" />
          <p class="com-margin-b">
            <span>公司</span>
            {{ name }}
          </p>
          <p>
            <span>行业</span>
            {{ classify }}
          </p>
        </div>
        <div class="item-text">
          <div class="com-tab-box" v-if="contentBlocks.length > 1">
            <div class="p-box">
                <p  :class="{ active: key == index }"  v-for="(item,index) in contentBlocks" :key="index" @click="choose(index)">{{item.title}}</p>
            </div>
          </div>
          <div class="content" v-html="content"></div>
        </div>
        <div class="item-desc p-desc">
          <img class="logo" :src="logoUrl || placeholder" alt="" />
          <p class="com-margin-b">
            <span>公司</span>
            {{ name }}
          </p>
          <p>
            <span>行业</span>
            {{ classify }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryCaseDetail } from "@/api/common";
// 1x1 透明占位图：数据未返回时保持 logo 槽位尺寸，避免布局跳动和破图图标
const PLACEHOLDER_IMG =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
export default {
  data() {
    return {
      name: "-",
      classify: "-",
      logoUrl: "",
      placeholder: PLACEHOLDER_IMG,
      key: 0,
      contentBlocks: [],
      content: '',
    };
  },
  methods: {
    goList() {
      this.$router.push({ name: "cases" });
    },
    choose(val) {
      this.key = val;
      this.content = this.contentBlocks[this.key].content
    },
    queryDetail() {
      let { id } = this.$route.query;
      queryCaseDetail(id).then((res) => {
        if (res && res.code == 200) {
          this.name = res.data.caseTitle;
          this.classify = res.data.categoryName;
          this.logoUrl = res.data.caseLogo;
          if(res.data.contentBlocks && res.data.contentBlocks.length) {
              this.contentBlocks = res.data.contentBlocks
              this.content = this.contentBlocks[0].content
          }
        }
      });
    },
  },
  mounted() {
    this.queryDetail();
  },
};
</script>